import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { InputAdornment, IconButton } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import TextField from './TextField';

const PasswordField = ({ name, label, className, disabled }) => {
  const [visiblePassword, setPasswordVisibility] = React.useState(false);

  const handleClickShowPassword = () => {
    setPasswordVisibility(!visiblePassword);
  };

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };

  return (
    <Field
      className={className}
      key={name}
      required
      name={name}
      label={label}
      type={visiblePassword ? 'text' : 'password'}
      component={TextField}
      inputProps={{
        endAdornment: (
          <InputAdornment position="end" >
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
            >
              {visiblePassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        )
      }}
      disabled={disabled}
    />
  )
};

PasswordField.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
};

PasswordField.defaultProps = {
  disabled: false,
}

export default PasswordField;
